module.exports = __webpack_public_path__ + "static/media/1.257928a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9029/1.jpg
// module id = 877
// module chunks = 0